// An in-page "are you sure?" for Settings, the same shape as Remove and Delete account: the
// question, then the action and Cancel, right under the button that asked. It replaces the
// browser's confirm(), which looks like a page error and can't be styled.
//
// Focus moves to the action button (like confirm()'s OK), the question labels the group so a
// screen reader reads it on the way in, and Esc or Cancel puts focus back on the button that
// opened it.

let seq = 0;

export function inlineConfirm({ doc = document, opener, text, okLabel, danger = true, onOk, onCancel }) {
	const box = doc.createElement("div");
	box.className = "rv-way-confirm";
	box.setAttribute("role", "group");
	const q = doc.createElement("p");
	q.className = "rv-account-note";
	q.textContent = text;
	q.id = "rv-confirm-q-" + (++seq);
	box.setAttribute("aria-labelledby", q.id);

	const button = (label, cls, fn) => {
		const b = doc.createElement("button");
		b.type = "button";
		b.className = "rv-btn" + (cls ? " " + cls : "");
		b.textContent = label;
		b.addEventListener("click", fn);
		return b;
	};
	let done = false;
	const close = () => {
		if (done) return;
		done = true;
		box.remove();
		if (opener) { opener.hidden = false; opener.focus(); }
		if (onCancel) onCancel();
	};
	const go = button(okLabel, danger ? "rv-btn-danger" : "", () => { if (!done) onOk(go, close); });
	const no = button("Cancel", "", close);
	box.addEventListener("keydown", (e) => {
		if (e.key !== "Escape") return;
		e.preventDefault();
		e.stopPropagation();
		close();
	});
	const acts = doc.createElement("div");
	acts.className = "rv-account-actions";
	acts.append(go, no);
	box.append(q, acts);
	return { box, go, no, close };
}
